import { IButtonColumn, IDataColumn } from "../interfaces/custom-work/customTable";


export class CustomTableTypeChecker {
  static isDataColumn(column: IDataColumn | IButtonColumn<any>): column is IDataColumn {
    return (column as IDataColumn).dataType !== undefined;
  }

  static isButtonColumn(column: IDataColumn | IButtonColumn<any>): column is IButtonColumn<any> {
    return (column as IButtonColumn<any>).buttonType !== undefined;
  }
}
